import { cn } from "@/lib/utils";
import ChatModelProviderIcon from "./ChatModelProviderIcon";

type Props = {
  modelId: string;
  className?: string;
  size?: number;
};

/** Plain provider square — cues live beside the name, not on the mark. */
export default function ChatModelProviderMark({
  modelId,
  className,
  size = 20,
}: Props) {
  return (
    <span
      aria-hidden="true"
      className={cn("relative inline-grid place-items-center", className)}
      style={{
        width: size,
        height: size,
        flex: "none",
        borderRadius: 999,
        background: "var(--co-tonal)",
      }}
    >
      <span className="relative z-[1]">
        <ChatModelProviderIcon modelId={modelId} />
      </span>
    </span>
  );
}
